import React from 'react';
import I18n from '../lib/i18n';
import { default as ToastMessage} from 'react-native-toast-message';

export default class Toast {
  static showMessage(message: string, duration?: number) {
    ToastMessage.show({
      type: 'success', 
      text1: I18n.t('toaster.info'),
      text2: message,
      visibilityTime: duration || 4000,
    });
  }
  static showError(message: string, duration?: number) {
    ToastMessage.show({
      type: 'error', 
      text1: I18n.t('toaster.error'),
      text2: message,
      visibilityTime: duration || 4000,
    });
  }
  static hide() {
    ToastMessage.hide();
  }
}
